export function checkDaysRange(range: number): number {
  return range / (24*60*60*1000);
}

export function addMonth(startDate: Date): Date {
  const newDate = new Date(startDate);
  newDate.setDate(newDate.getDate() + 31);
  return newDate;
}

export function getMinMax(rangeStart: number, rangeEnd: number, ms = 600000) {
  const min = rangeStart / ms;
  const max = rangeEnd / ms;
  return { min, max };
}

export function getPeriod(date: Date): number {
  const year = date.getFullYear();
  const month = date.toLocaleString('default', {month: '2-digit'});
  return +`${year}${month}`;
}

export function setStart(date: Date): number {
  const newDate = new Date(date);
  newDate.setDate(newDate.getDate() - 31);
  return newDate.getTime();
}